import React, { useEffect, useState } from 'react'
import FetchData from '../../shared/fetchData'
import Title from './Title/Title'
import './FAQContent.css'
import { Row, Col } from "reactstrap"
import Fade from 'react-reveal/Fade'

        const FAQContent = (props) => {

    const [faqTitles, setFaqTitles] = useState([])
    const [showForm, setShowForm] = useState(false)
    const [titleId, setTitleId] = useState('50')
    const [contents, setContents] = useState([])


    useEffect(() => {
        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({"version": "mtpx001"})
        var url = 'api/v1/configurations/getFaqTitles'
        FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setFaqTitles(result.faqTitles)
                })
                .catch(error => console.log('error', error))
        var cRaw = JSON.stringify({"titleId": titleId, "version": "mtpx001"})
        var cUrl = 'api/v1/configurations/getFaqContents'
        FetchData(cRaw, cUrl).then(response => response.json())
                .then(result => {
                    console.log(result.faqContents)
                    setContents(result.faqContents)
                })
                .catch(error => console.log('error', error))
    }, []);
    const chooseTitle = (id) => {
        setTitleId(id)
        var cRaw = JSON.stringify({"titleId": id, "version": "mtpx001"})
        var cUrl = 'api/v1/configurations/getFaqContents'
        console.log(cRaw)
        FetchData(cRaw, cUrl).then(response => response.json())
                .then(result => {
                    console.log(result.faqContents)
                    setContents(result.faqContents)
                })
                .catch(error => console.log('error', error))
    }
    const titles = faqTitles.map(f => {
        return <Title isActive={titleId == f.id ? true : false} key={f.id} title={f} chooseTitle={(id) => chooseTitle(id)} />
    })
    const content = contents.map(c => {
        let ques = <td dangerouslySetInnerHTML={{__html: c.question}} />
        let res = <td dangerouslySetInnerHTML={{__html: c.response}} />
        return (
                <div className="ContentCntnr">
                    <div className="Question">
                        <div className="col-12">
                            {ques}
                        </div>
                    </div>
                    <div className="Response">
                        <div className="col-12">
                            {res}
                        </div>
                    </div>
                </div>
                )
    })
    return (
            <Fade duration={200} left cascade>
                <div>
                    <div className="row justify-content-center mt-5">
                        <div className="faq-contents">
                            <div className="row small-faq-cntnr">
                                {titles}
                            </div>
                        </div>
                        {content}
                    </div>
                </div>
            </Fade>
            )
}

export default FAQContent;